'use strict';

module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};



//////////////////
// WEBPACK FOOTER
// ./~/annonces-app-modules/~/axios/lib/cancel/isCancel.js
// module id = 48
// module chunks = 0